'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _ContentCardEmbeddedVideo = require('../ContentCardEmbeddedVideo');

var _ContentCardEmbeddedVideo2 = _interopRequireDefault(_ContentCardEmbeddedVideo);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YouTubeContentCard = function YouTubeContentCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ContentCardEmbeddedVideo2.default, {
      src: 'https://www.youtube.com/embed/' + props.videoID + '?rel=0&showinfo=0',
      modalEnabled: props.modalEnabled
    }),
    _react2.default.createElement(
      'a',
      { href: props.url, target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(_ContentCardText2.default, { source: 'youtube', text: props.title })
    ),
    props.messengerShareButton
  );
};

YouTubeContentCard.propTypes = {
  channelTitle: _propTypes2.default.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  messengerShareButton: _propTypes2.default.node,
  title: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string,
  videoID: _propTypes2.default.string.isRequired,
  modalEnabled: _propTypes2.default.bool
};

YouTubeContentCard.defaultProps = {
  messengerShareButton: null,
  url: null,
  caption: '',
  modalEnabled: false
};

YouTubeContentCard.displayName = 'YouTubeContentCard';

exports.default = (0, _withContentCardFooter2.default)(YouTubeContentCard);